import { StarFilled, StarOutlined } from '@ant-design/icons';
import { Product, WaterbodyDetail } from '@omniafishing/core';
import React, { useState } from 'react';
import { useQueryString } from '../../hooks/use_query_string';
import { useResponsive } from '../../hooks/use_responsive';
import { OmniaButton } from '../omnia_button/omnia_button';
import { WaterbodyDetailFollowModal } from '../waterbody_detail/waterbody_detail_sections/waterbody_detail_follow/waterbody_detail_follow_modal';
import styles from './waterbody_follow_button_logged_out.less';

interface WaterbodyFollowButtonLoggedOutProps {
  alwaysMicroButton?: boolean;
  microMobileButton?: boolean;
  onClick?: () => void;
  waterbody: WaterbodyDetail;
  productToShow?: Product;
  className?: string;
  context?: 'lake_page' | 'state_page';
  defaultSpeciesName?: string;
  buttonType?: 'primary' | 'tertiary';
  buttonSize?: 'lg' | 'md' | 'sm';
}
export const WaterbodyFollowButtonLoggedOut = (props: WaterbodyFollowButtonLoggedOutProps) => {
  const {
    waterbody,
    onClick,
    productToShow,
    alwaysMicroButton,
    microMobileButton,
    className,
    context = 'lake_page',
    defaultSpeciesName,
    buttonType = 'primary',
    buttonSize = 'lg',
  } = props;
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery();
  const isFollowing = !!currentQuery.following;
  const selectedSpeciesName = currentQuery.species as string;
  const isLakePage = context === 'lake_page';
  const isStatePage = context === 'state_page';
  const { isMobile } = useResponsive();
  return (
    <div className={className}>
      <OmniaButton
        onClick={() => {
          setNotificationModalOpen(true);
          onClick?.();
        }}
        size={buttonSize}
        kind={buttonType}
        shape={(isMobile && microMobileButton) || alwaysMicroButton ? 'square' : 'rectangle'}
        isDisabled={isLakePage ? isFollowing : disabled}
      >
        {isStatePage && disabled ? (
          <StarFilled className={styles.starIcon} />
        ) : (
          <StarOutlined className={styles.starIcon} />
        )}
        {(isMobile && microMobileButton) || alwaysMicroButton ? '' : 'Follow'}
      </OmniaButton>
      <WaterbodyDetailFollowModal
        waterbody={waterbody}
        open={notificationModalOpen}
        onModalChange={(value: boolean) => setNotificationModalOpen(value)}
        productToShow={productToShow}
        selectedSpeciesName={defaultSpeciesName || selectedSpeciesName}
        onSuccess={() => setDisabled(true)}
      />
    </div>
  );
};
